var exports = {
  "w": "xae11d333--cbc0ab--header",
};

module.exports = exports;
